import type { UseQueryResult } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import {
  CONTRACT_RECONCILE_POLL_MS,
  createContractReadinessHook,
  shouldPollContractReadiness,
} from "./contract-readiness-query"
import type { BatteryContractReadinessDto } from "../dto/battery-contract.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/** Poll while DocuSign outcome is still being matched for an open Contract drawer. */
export const BATTERY_CONTRACT_RECONCILE_POLL_MS = CONTRACT_RECONCILE_POLL_MS

export const shouldPollBatteryContractReadiness: (
  readiness: BatteryContractReadinessDto | undefined,
) => boolean = shouldPollContractReadiness

const useReadiness = createContractReadinessHook<BatteryContractReadinessDto>({
  queryKey: queryKeys.batteryProposal.contract,
  fetchReadiness: (proposalId) =>
    batteryProposalService.getContractReadiness(proposalId),
  missingIdMessage: `Battery-Only Proposal id is required`,
})

/**
 * Server-derived Battery contract readiness, fetched while the Contract drawer
 * is open. Pricing refresh (including a superseded race), Setup details,
 * adders, and warranty saves invalidate it.
 */
export default function useBatteryContractReadiness(
  proposalId: string | undefined,
): UseQueryResult<BatteryContractReadinessDto> {
  return useReadiness(proposalId)
}
